var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReportResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.7,31.25l11.45-11.45-1.95-1.95-9.5,9.5-5.15-5.15-1.95,1.95,7.1,7.1Zm-10.7,8.75c-.8,0-1.5-.3-2.1-.9s-.9-1.3-.9-2.1V3c0-.8.3-1.5.9-2.1s1.3-.9,2.1-.9h18.05l10.95,10.95v26.05c0,.8-.3,1.5-.9,2.1s-1.3.9-2.1.9H3ZM19.55,12.3V3H3v34h26V12.3h-9.45ZM3,3v9.3V3v34V3Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportResults);
export default __webpack_public_path__ + "static/media/report-results.3c2ab73ef912f653d62b7206776274d1.svg";
export { ForwardRef as ReactComponent };